import { useMemo } from "react";
import { getCandidateStatusKey } from "../../../../../utilities/candidate";

export const useVisibleTransitions = (transitions) => {
  return useMemo(() => {
    if (!transitions.some((t) => t.isCustom)) return transitions;

    const customRouteNodes = new Set(
      transitions
        .filter((t) => t.isCustom)
        .flatMap((t) => [
          getCandidateStatusKey(t.fromStatusId, t.fromSubStatusId),
          getCandidateStatusKey(t.toStatusId, t.toSubStatusId),
        ]),
    );

    return transitions.filter(
      (t) =>
        t.isCustom ||
        t.isActive ||
        (!customRouteNodes.has(
          getCandidateStatusKey(t.fromStatusId, t.fromSubStatusId),
        ) &&
          !customRouteNodes.has(
            getCandidateStatusKey(t.toStatusId, t.toSubStatusId),
          )),
    );
  }, [transitions]);
};
